module.exports = __webpack_public_path__ + "static/media/jt9.a76414ad.png";